// Browser detection for MS IE
export default function isInternetExplorer() {
  return process.browser && window.document.documentMode;
}
